import { Skeleton } from '@src/components/ui/skeleton';
import { cn } from '@src/lib/utils';

import PdfFrameViewer from './PdfFrameViewer';

import { css } from '@emotion/css';
import { ShadcnSuspense } from '@shadcn-features/suspense';
import { FileText } from 'lucide-react';
import { CSSProperties } from 'react';

const PdfViewer = ({
    pdf,
    style,
    spinStyle,
    frameStyle,
    loading,
    className,
}: {
    pdf?: string;
    style?: CSSProperties;
    frameStyle?: CSSProperties;
    spinStyle?: CSSProperties;
    loading?: boolean;
    className?: string;
}) => {
    const initLoading = loading || !pdf;

    const PdfViewComponent = PdfFrameViewer;

    return (
        <div
            className={cn('flex h-full min-h-0 flex-1 self-stretch', className)}
        >
            <ShadcnSuspense
                override={{ loading: initLoading }}
                className='flex h-full min-h-0 flex-1'
                style={{ height: '100%', minHeight: 0, width: '100%' }}
                spin={
                    <Skeleton
                        className={css`
                            width: 100% !important;
                            height: 100% !important;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        `}
                        style={{
                            width: '100%',
                            height: '100%',
                            borderRadius: '0px',
                            ...spinStyle,
                        }}
                    >
                        <FileText style={{ fontSize: 40, color: '#bfbfbf' }} />
                    </Skeleton>
                }
            >
                <PdfViewComponent
                    className='h-full'
                    pdf={pdf!}
                    style={style ?? frameStyle}
                />
            </ShadcnSuspense>
        </div>
    );
};

export default PdfViewer;
